import { checkLang } from '@/tools/tools';
import type { AiLang, RuntimeImage, SunonAiConfig } from '@/types/runtime-config';

const allowedLanguages: readonly AiLang[] = ['en', 'ch', 'russia'];

const fallbackConfig: SunonAiConfig = {
  lang: checkLang(),
  placeholder: '',
  langBaseUrl: '/lang',
  assetsBaseUrl: '/images',
  chatApiUrl: '/wp-json/sunon-ai/v1/chat',
  feedbackApiUrl: '/wp-json/sunon-ai/v1/feedback',
  tagHitsApiUrl: '/wp-json/sunon-ai/v1/tag-hits',
  images: {},
};
export const runtimeConfig: SunonAiConfig = {
  ...fallbackConfig,
  ...window._AI_CONFIG,
  lang: window._AI_CONFIG?.lang || fallbackConfig.lang,
  langBaseUrl: window._AI_CONFIG?.langBaseUrl || fallbackConfig.langBaseUrl,
  chatApiUrl: window._AI_CONFIG?.chatApiUrl || fallbackConfig.chatApiUrl,
  feedbackApiUrl: window._AI_CONFIG?.feedbackApiUrl || fallbackConfig.feedbackApiUrl,
  tagHitsApiUrl: window._AI_CONFIG?.tagHitsApiUrl || fallbackConfig.tagHitsApiUrl,
  images: window._AI_CONFIG?.images ?? fallbackConfig.images,
};
(window as any).runtimeConfig = runtimeConfig;

export const runtimeImageUrls = (images?: RuntimeImage[]): string[] => {
  return images?.map(image => image.url).filter(Boolean) ?? [];
};
